import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { useNavigate } from 'react-router-dom'
import { MeResponse } from '@magnetar/admin-api-interfaces'
import { logger } from '@magnetar/utils'

export function useMe() {
  const { token, clearAuthToken } = useAuth()
  const navigate = useNavigate()

  const {
    data: response,
    error,
    isLoading,
    mutate,
  } = useGet<MeResponse>(
    token ? '/api/me' : null,
    undefined,
    token ?? '',
    () => {
      clearAuthToken()
      navigate('/login')
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  )

  if (error) {
    logger.error('User fetch error:', error)
  }

  // 從 response 中提取 data
  const user = response?.success ? response.data : undefined

  return {
    user,
    isLoading,
    isError: error,
    mutate,
  }
}
